export default "__VITE_ASSET__C8UtORsd__"